/**
 * @generated SignedSource<<f2b0c074bba55111ff483fb96032dabf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user" | "PdpRespPricingGuidance_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanel_user";
};
export type PdpRespAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9726cca05b03483c0754e8f4acd1b5e1";

export default node;
